import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  message?: string;
}

export default function LoadingSpinner({ 
  size = 'md', 
  fullScreen = true, 
  message = 'Loading...' 
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  const containerClasses = fullScreen 
    ? 'fixed inset-0 flex items-center justify-center bg-white bg-opacity-90 z-50'
    : 'flex items-center justify-center p-4';

  return (
    <div className={containerClasses}>
      <div className="text-center">
        <div className="animate-spin rounded-full border-b-2 border-blue-600 mx-auto mb-4" 
             style={{ 
               height: size === 'sm' ? '16px' : size === 'md' ? '32px' : '48px',
               width: size === 'sm' ? '16px' : size === 'md' ? '32px' : '48px'
             }}>
        </div>
        <p className="text-gray-600 text-sm">{message}</p>
      </div>
    </div>
  );
} 